// Polis, l'onglet Projections (17 octobre 2026) : le contrôle de l'assemblée dont l'élection fait partie.
export default {
  titre: 'Le contrôle {deAssemblee}',
  pct: '{n} %',
  moinsDeUn: '< 1',
  plusDe99: '> 99',
  fourchette: '{bas} ~ {haut}',
  aria: '{dem} sièges contre {rep}, sur {sieges}',
  verdict: {
    garde: '{camp} gardent {assemblee} dans {p} des cas.',
    prend: '{camp} prennent {assemblee} dans {p} des cas.',
    obtient: '{camp} tiennent {assemblee} dans {p} des cas.',
    autre: '{camp}, dans {p}.',
    aucun: 'Dans {p}, un indépendant non aligné tient la clé.',
  },
  majorite: 'Le trait : la majorité, {n} sièges.',
  departage: 'À égalité, le vice-président départage pour {camp}.',
  courses: {
    titre: 'Les courses',
    legende: 'la chance de l’emporter pour {camp}',
    classement: 'se joue d’avance',
    margeDem: 'démocrate +{n}',
    margeRep: 'républicain +{n}',
    egalite: 'à égalité',
    independant: '{nom} (indépendant)',
    jumeaux: 'jumeaux {p}',
  },
  // Le contrôle selon les jumeaux (20 octobre 2026), à côté de celui des sondages.
  jumeaux: {
    titre: 'Selon les jumeaux :',
    sieges: '{campDem} {dem} sièges, {campRep} {rep}.',
    controle: '{camp} le tiennent dans {p} des cas.',
  },
  acquis: 'Hors scrutin : {dem} sièges pour {campDem} (indépendants qui siègent avec eux compris), {rep} pour {campRep}.',
  jouees: 'Courses jouées d’avance : {dem} pour {campDem}, {rep} pour {campRep}.',
  chambre: {
    national: 'Vote national projeté : {marge}.',
    disputees: '{n} circonscriptions disputées.',
    legende: 'Les plus disputées, avec la chance de l’emporter pour {camp}.',
  },
}
